// extracted by mini-css-extract-plugin
export default {"user_badge":"LogoutBadge_user_badge__YTNLT","logout_icon":"LogoutBadge_logout_icon__uTJQB"};